import Button from '../../../components/common/Button';
import { FaTimes } from "react-icons/fa";

const Plazo = ({ plazos, dias, handleInputChange, quitarPlazo, quitarPlazoDetalle }) => {
    return (
        <>
            {plazos.map((tramite) => (
                <div key={tramite.id} className="mb-2 p-2 border border-gray-300 rounded-lg shadow-md bg-gray-50" >
                    <div className='flex items-center justify-between gap-2'>
                        <h3 className="mb-1 text-md font-semibold text-gray-800">{tramite.tramite}</h3>
                        <Button onClick={(e) => quitarPlazo(e, tramite.id)} type="delete" texto={<FaTimes />} />
                    </div>

                    {tramite.plazos_detalle.map((detalle) => (
                        <div key={detalle.id} className="flex items-center mb-2 p-1 bg-white rounded shadow-sm border border-gray-200" >
                            <button  className="p-1 hover:bg-red-300 rounded-full text-red-600 hover:text-red-800 focus:outline-none"  onClick={(e) => quitarPlazoDetalle(e, tramite.id, detalle.id)} >
                                <FaTimes size={16} />
                            </button>
                            {/* Input para días */}
                            <input
                                type="number"
                                value={dias[detalle.id] || 0} // Valor predeterminado de 0
                                onChange={(e) => handleInputChange(e, tramite.id, detalle.id)} // Actualiza el valor de días al cambiarlo
                                placeholder="Días"
                                className="mr-3 p-2 w-20 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                            />
                            {/* Descripción */}
                            <span className="text-gray-700">{detalle.descripcion}</span>
                        </div>
                    ))}
                </div>

            ))}
        </>
    );
};

export default Plazo;
